import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import EditIcon from "@mui/icons-material/Edit";
import { Dialog, DialogContent, DialogTitle, Grid } from "@mui/material";
import PropTypes from "prop-types";
import "./keywordUploadMethodModal.scss";

const KeywordUploadMethodModal = ({
  isOpen,
  onClose,
  onSelectManual,
  onSelectUpload,
}) => {
  if (!isOpen) return null;

  return (
    <Dialog
      className="keyword-upload-method-modal"
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Grid container justifyContent="space-between" direction="row">
          <Grid item xs={10}>
            <h2 data-testid="keyword-upload-method-title">Add Keywords</h2>
          </Grid>
          <Grid item xs={1} display="flex" justifyContent="flex-end">
            <CloseIcon
              onClick={onClose}
              className="cursor-pointer"
              data-testid="keyword-upload-method-close"
            />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <div className="upload-method-options">
          <div
            className="upload-method-card"
            data-testid="upload-list-option"
            onClick={onSelectUpload}
          >
            <CloudUploadIcon className="upload-method-icon" fontSize="large" />
            <div className="upload-method-text">
              <h3>Upload List</h3>
              <p>Upload a CSV file with keyword groups</p>
            </div>
          </div>
          <div
            className="upload-method-card"
            data-testid="upload-manual-option"
            onClick={onSelectManual}
          >
            <EditIcon className="upload-method-icon" fontSize="large" />
            <div className="upload-method-text">
              <h3>Add Manually</h3>
              <p>Enter keyword group details manually</p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

KeywordUploadMethodModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectManual: PropTypes.func.isRequired,
  onSelectUpload: PropTypes.func.isRequired,
};

export default KeywordUploadMethodModal;
